/**
 * Parses rich text HTML into pptxgenjs text runs
 * @param {String} richText
 * @returns {Array<Object>}
 */
export const parseRichTextToPptRuns = (richText = '') => {
  const runs = [];
  const parser = new DOMParser();
  const html = typeof richText === 'string' ? richText : '';
  const doc = parser.parseFromString(html, 'text/html');

  const processNode = (node, styles = {}) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent;
      if (text) {
        runs.push({
          options: styles,
          text,
        });
      }
      return;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) return;

    const tag = node.tagName.toLowerCase();

    const nextStyles = {
      ...styles,
      ...(tag === 'b' || tag === 'strong' ? { bold: true } : {}),
      ...(tag === 'i' || tag === 'em' ? { italic: true } : {}),
      ...(tag === 'u' ? { underline: true } : {}),
    };

    node.childNodes.forEach((child) => processNode(child, nextStyles));
  };

  doc.body.childNodes.forEach((node) => processNode(node));

  return runs.length > 0 ? runs : [];
};
